import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import secImage from "../../assets/learing-quran-with1.webp";

const SecondSection = () => {
  return (
    <section style={sectionStyle}>
      <Container>
        <Row className="align-items-center">
          {/* Left Column: Image */}
          <Col lg={6} className="mb-4 mb-lg-0">
            <div style={{ overflow: "hidden" }}>
              <motion.div
                initial={{ x: -200, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 1.2, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Image
                  src={secImage}
                  alt="Quran Learning"
                  fluid
                  rounded
                  style={{
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    width: "90%",
                  }}
                />
              </motion.div>
            </div>
          </Col>
          {/* Right Column: Text */}
          <Col lg={6}>
            <div style={{ overflow: "hidden" }}>
              <motion.div
                initial={{ x: 200, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h2 style={titleStyle}>Learn Quran With TaleemulQuran</h2>
                <h3 style={subTitleStyle}>Assalamu Alaikum!</h3>
                <p style={textStyle}>
                  Do you want to learn the Quran online with Tajweed from
                  professional and qualified Huffaz? Our online Quran tuition
                  helps you explore the great beauty of the Holy Quran, starting
                  from basics and moving toward more advanced lessons with
                  focused one‑on‑one instruction.
                </p>
                <p style={textStyle}>
                  We provide lessons with interactive activities tied to
                  fundamentals like Tajweed (correct pronunciation), Arabic
                  reading rules, stories of the prophets, and basic Islamic
                  teachings alongside Quran studies. TaleemulQuran aims to make
                  learning easy and engaging for both children and adults.
                </p>
                <p style={textStyle}>
                  By joining this platform you can improve your Quran
                  recitation, reading fluency, and overall understanding of the
                  scripture.
                </p>
              </motion.div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

// Inline styling
const sectionStyle = {
  backgroundColor: "#f9f9f9",
  padding: "80px 0",
};

const titleStyle = {
  fontSize: "2rem",
  fontWeight: "700",
  marginBottom: "1rem",
  color: "#0d3b66",
};

const subTitleStyle = {
  fontSize: "1.5rem",
  fontWeight: "500",
  marginBottom: "1.5rem",
  color: "#1d4e89",
};

const textStyle = {
  fontSize: "1.05rem",
  lineHeight: "1.8",
  color: "#333",
  marginBottom: "1.2rem",
  textAlign: "justify",
};

export default SecondSection;
